import { ReactNode } from "react"
import { UncontrolledTooltip } from "reactstrap"

interface InfoTipProps {
    // Unique per page; must not start with a digit (it becomes a CSS selector)
    id: string
    text: ReactNode
}

// Small info icon next to a title; hovering explains what the section is and where its data comes from.
const InfoTip = ({ id, text }: InfoTipProps) => {
    const targetId = `info-${id}`
    return <>
        <i id={targetId} className="mdi mdi-information-outline info-tip" aria-label="More information" tabIndex={0} />
        <UncontrolledTooltip target={targetId} placement="top">
            <div style={{ textAlign: "left" }}>{text}</div>
        </UncontrolledTooltip>
    </>
}

export default InfoTip
